import PostListCard from 'src/modules/community/shared/components/sidebar/postListCard';
import i18n from 'src/utils/translate';
import { PopularPost } from 'src/constants/types';
type Props = {
  posts: PopularPost[];
};
export default function PopularPosts({
  posts = []
}: Props) {
  if (posts.length === 0) return null;
  return <PostListCard posts={posts} postType="popular-post" title={i18n.t('Popular Posts')} data-sentry-element="PostListCard" data-sentry-component="PopularPosts" data-sentry-source-file="popularPosts.tsx" />;
}